import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const hasFetchedUserData = useRef(false);

    useEffect(() => {
        if (hasFetchedUserData.current) return;
            hasFetchedUserData.current = true;

            const checkAuth = async () => {
                try {
                    const res = await axios.get(API_ROUTES.CHECK_AUTH, { withCredentials: true });
                    const { authenticated, user } = res.data;

                    setIsAuthenticated(authenticated);
                    setUser(authenticated ? user : null);
                    setError(null);

                } catch (err) {
                    // Esto ya es un error REAL (500, red, backend caído, etc.)
                    console.error('[useAuth] Error real:', err);
                    setIsAuthenticated(false);
                    setUser(null);
                    setError('Error al verificar la sesión');
                } finally {
                    setLoading(false);
                }
            };

            checkAuth();
    }, []);

    return { isAuthenticated, setIsAuthenticated, user, loading, error };
};

export default useAuth;